<template>
  <div class="tp-container">
    <!-- 顶部统计 -->
    <div class="tp-top">
      <div class="chart-ratio" ref="chart-ratio"></div>
      <div class="ratio-group">
        <div class="ratio-item">
          <div>
            <div class="ratio-item-number" ref="ratioTotal">
              {{ item.ratioTotal }}
            </div>
            <div>总停车位</div>
          </div>
        </div>
        <div class="ratio-item">
          <div>
            <div class="ratio-item-number" ref="ratioNumber">
              {{ item.ratioNumber }}
            </div>
            <div>已停车位</div>
          </div>
        </div>
        <div class="ratio-item">
          <div>
            <div class="ratio-item-number" ref="ratioNull">
              {{ item.ratioTotal - item.ratioNumber }}
            </div>
            <div>空余车位</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 折线统计图 -->
    <div class="chart-line" ref="chart-line"></div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([
        this.$refs.ratioNumber,
        this.$refs.ratioTotal,
        this.$refs.ratioNull,
      ])
    },
    methods: {
      init() {
        this.ratioChart()
        this.lineChart()
      },
      // 车位使用率
      ratioChart() {
        let chartDom = this.$refs['chart-ratio']
        let myChart = this.$echarts.init(chartDom)
        let option = {
          title: [
            {
              text: '车位使用率',
              x: 'center',
              top: '50%',
              textStyle: {
                color: '#FFFFFF',
                fontSize: 10,
                fontWeight: '100',
              },
            },
            {
              text:
                ((this.item.ratioNumber / this.item.ratioTotal) * 100).toFixed(
                  0
                ) + '%',
              x: 'center',
              top: '28%',
              textStyle: {
                fontSize: '16',
                color: '#FFFFFF',
                fontFamily: 'DINAlternate-Bold, DINAlternate',
                foontWeight: '600',
              },
            },
          ],
          polar: {
            radius: ['84%', '94%'],
            center: ['50%', '50%'],
          },
          angleAxis: {
            max: this.item.ratioTotal,
            show: false,
          },
          radiusAxis: {
            type: 'category',
            show: true,
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          series: [
            {
              name: '',
              type: 'bar',
              roundCap: true,
              barWidth: 90,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(66, 66, 66, .3)',
              },
              data: [this.item.ratioNumber],
              coordinateSystem: 'polar',

              itemStyle: {
                normal: {
                  color: '#FFCC02',
                },
              },
            },
            {
              name: '',
              type: 'pie',
              startAngle: 80,
              radius: ['98%'],
              hoverAnimation: false,
              center: ['50%', '50%'],
              itemStyle: {
                color: 'rgba(66, 66, 66, .1)',
                borderWidth: 1,
                borderColor: 'rgba(2, 255, 163, 0.5)',
              },
              data: [this.item.ratioTotal],
            },
            {
              name: '',
              type: 'pie',
              startAngle: 80,
              radius: ['80%'],
              hoverAnimation: false,
              center: ['50%', '50%'],
              itemStyle: {
                color: 'rgba(66, 66, 66, .1)',
                borderWidth: 1,
                borderColor: 'rgba(2, 255, 163, 0.5)',
              },
              data: [this.item.ratioTotal],
            },
          ],
        }
        myChart.setOption(option)
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.ratioNumber,
          innerHTML: [0, this.item.ratioNumber],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.ratioTotal,
          innerHTML: [0, this.item.ratioTotal],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.ratioNull,
          innerHTML: [0, this.item.ratioTotal - this.item.ratioNumber],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
      // 折线统计图
      lineChart() {
        let chartDom = this.$refs['chart-line']
        let myChart = this.$echarts.init(chartDom)
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#57617B',
              },
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#57617B',
                },
              },
              axisLabel: {
                textStyle: {
                  color: '#fff',
                  fontSize: 12,
                },
              },
              data: this.item.xData,
            },
          ],
          yAxis: [
            {
              type: 'value',
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#57617B',
                },
              },
              axisLabel: {
                margin: 10,
                textStyle: {
                  color: '#fff',
                  fontSize: 12,
                },
              },
              splitLine: {
                lineStyle: {
                  color: '#57617B',
                },
              },
            },
          ],
          series: [
            {
              name: '',
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 2,
                },
              },
              areaStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: 'rgba(2, 255, 163, 0.7)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(2, 255, 163, 0.1)',
                      },
                    ],
                    false
                  ),
                  shadowColor: 'rgba(0, 0, 0, 0.1)',
                  shadowBlur: 10,
                },
              },
              itemStyle: {
                normal: {
                  color: '#02FFA3',
                },
                emphasis: {
                  color: 'rgb(0,196,132)',
                  borderColor: 'rgba(0,196,132,0.2)',
                  extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
                  borderWidth: 10,
                },
              },
              data: this.item.val,
            },
          ],
        }
        myChart.setOption(option)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tp-container {
    .tp-top {
      padding: 0.52083vw;
      display: flex;
      .chart-ratio {
        height: 4.6875vw;
        width: 4.6875vw;
      }
      .ratio-group {
        flex-grow: 1;
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        .ratio-item {
          width: 30%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
          text-align: center;
          color: white;
          font-size: 12px;
          .ratio-item-number {
            font-size: 1.1458vw;
            margin-bottom: 0.7291vw;
          }
        }
      }
    }
    .chart-line {
      height: 14vh;
    }
  }
</style>
